import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { ILoader } from "libraries/component/loader/ILoader";
import { LoaderType } from "libraries/component/loader/loader.component";
import { Yii } from "libraries/interfaces/Yii";
import { INotification } from "libraries/interfaces/INotification";
import { FLUTTER_APPS } from "app/flutter.apps.generated";
import { EHosts } from "libraries/enums/EHosts";
import {
    ResponseForConvertSearchAddOnAfx2jsonType
} from "@afidium/ts-facade/model/responseForConvertSearchAddOnAfx2jsonType";
import { IActionOutput } from "libraries/component/iframe-app-embedder/iframe-app-embedder.component";
import { IGetBookingsAirResponse } from "libraries/service/resources/booking/interfaces/IGetBookings";

@Component({
    selector: 'booking-ancillary-services-page',
    template: `
        <iframe-app-embedder-ancillary-services [iframeSrc]="appUrl"
                                                [iframeName]="'ancillaryServicesPage'"
                                                [isDynamicHeight]="false"
                                                [isFullHeight]="true"
                                                [additionalData]="additionalData"
                                                (onIframeEvent)="doAction($event)">
        </iframe-app-embedder-ancillary-services>
    `,
    styles: [
        `
            iframe-app-embedder-ancillary-services {
                height: calc(100vh - 80px);
            }
        `
    ]
})
export class BookingAncillaryServicesPageComponent implements OnInit, OnChanges {

    @Input()
    public searchAddOnResponse: ResponseForConvertSearchAddOnAfx2jsonType;

    @Output()
    public readonly onServiceCancel: EventEmitter<void> = new EventEmitter<void>();

    @Output()
    public readonly onServiceAdd: EventEmitter<IGetBookingsAirResponse> = new EventEmitter<IGetBookingsAirResponse>();

    public appUrl: string;

    public additionalData: { servicesRequestBase: any, bookingWithServicesResponse: any };

    public loader: ILoader = {
        active: true,
        type: LoaderType.large,
        message: Yii.t('wui-shared-js', 'Chargement en cours'),
    };

    public notification: INotification = {
        active: false,
        message: Yii.t('wui-shared-js', 'Une erreur est survenue.'),
    };

    constructor(
        private readonly changeDetectorRef: ChangeDetectorRef,
    ) {
    }

    public ngOnInit(): void {
        this.appUrl = FLUTTER_APPS.ancillary_services_app;
        if (this.searchAddOnResponse) {
            this.additionalData = {
                servicesRequestBase: this.getRequestBase(),
                bookingWithServicesResponse: {
                    error: false,
                    warning: false,
                    code: 200,
                    message: null,
                    data: this.searchAddOnResponse,
                }
            };
            this.changeDetectorRef.detectChanges();
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes?.booking?.currentValue && !changes?.booking?.firstChange) {
            this.additionalData = {
                servicesRequestBase: this.getRequestBase(),
                bookingWithServicesResponse: {
                    error: false,
                    warning: false,
                    code: 200,
                    message: null,
                    data: this.searchAddOnResponse,
                }
            };
            this.changeDetectorRef.detectChanges();
        }
    }

    public doAction(actionOutput: IActionOutput): void {
        console.log({actionOutput})
        switch (actionOutput.name){
            case "serviceCancellation":
                this.onServiceCancel.emit();
                break;
            case "serviceAddToBooking":
                this.onServiceAdd.emit(actionOutput.updatedBooking.data as unknown as IGetBookingsAirResponse);
                break;
            default:
                break;
        }
    }

    private getRequestBase(): any {
        let host: string = this.searchAddOnResponse.booking.host.code;
        if (this.searchAddOnResponse.booking.host.code.toUpperCase() === EHosts.GALILEO) {
            host = EHosts.TRAVELPORT;
        }
        return {
            booking: {
                syscodeValue: this.searchAddOnResponse.booking.syscode.value,
                host: {
                    code: host,
                    xTarget: this.searchAddOnResponse.booking.xTarget
                }
            }
        };
    }
}
